import { focusOutline } from "@ui/css/02.focus/focus.styles";

export const styles = {
    itemsWrapper: {
        fontSize: "desktopBodyTextSmall",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "210px",
        padding: 2,
    },
    itemContainer: {
        display: "flex",
        justifyContent: "flex-start",
        gap: 2,
        width: "100%",
        _active: {
            background: "transparent",
            outline: "none",
        },
        _hover: {
            background: "transparent",
            outline: "none",
            _disabled: {
                cursor: "default",
                pointerEvents: "none",
            },
        },
        _focus: {
            ...focusOutline,
            _hover: {
                background: "transparent",
                outline: "none",
            },
        },
        _disabled: {
            pointerEvents: "none",
            color: "gray.500",
        },
    },
    item: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
    },
};
